import filterHelper from 'app/helpers/filterHelper';
import { ProductFilter } from 'app/shared/model/ProductBase';
import { applyProductStatusFilter, ProductStatusFilterValue } from './productStatusFilterUtils';

export function buildGridFilteredList<T extends { active?: boolean }>(
  fullList: T[],
  options: {
    showFilters: boolean;
    filters: ProductFilter[];
    isSearchActive: boolean;
    searchFilteredData: T[] | undefined;
    statusFilter: ProductStatusFilterValue;
  }
): T[] | undefined {
  const { showFilters, filters, isSearchActive, searchFilteredData, statusFilter } = options;

  let data: T[];
  if (showFilters) {
    data = filters.length > 0
      ? (filterHelper.multipleFilter(fullList, filters) as T[])
      : fullList;
  } else if (isSearchActive && searchFilteredData !== undefined) {
    data = searchFilteredData;
  } else {
    data = fullList;
  }

  const statusFiltered = applyProductStatusFilter(data, statusFilter);
  const hasPanelFilters = showFilters && filters.length > 0;
  const hasSearch = !showFilters && isSearchActive;
  const hasStatusFilter = statusFilter !== 'all';

  if (!hasPanelFilters && !hasSearch && !hasStatusFilter) {
    return undefined;
  }

  return statusFiltered;
}